import React from 'react';


import VelacionCasa from '../../assets/Imagenes/Home/velacion en casa.png'
import './styles.css';



import {
  Box,
  Card,
  CardMedia,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const VelacionEnCasaCard = ({ ParrafoMargin,Margin,Height,onClick, Imagen, ColorTarjeta, Icono, TituloContenido, TituloSize, TituloColor, TituloWeight, TituloAlign, ParrafoContenido, ParrafoSize, ParrafoColor, ParrafoWeight, ParrafoAlign, ListaContenido, ListaSize, ListaColor, ListaWeight, ListaAlign }) => {
  return (
    < Box
      sx={{
        margin:Margin,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}>
      <Card 
        sx={{
          maxWidth: '100%',
          height: '100%',
          borderRadius: 4,
          overflow: 'visible',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          mx: 'auto',
          position: 'relative',
        }}
      >
        {/* Imagen superior con border radius */}
        <CardMedia
          component="img"
          // height="200"
          image={Imagen}
          alt="Velación en casa"
          sx={{
            aspectRatio: '1 / 1',
            width: '100%',
            objectFit: 'cover',
            borderRadius: '16px'
          }}
        />

        {/* Tarjeta rosa que flota sobre la imagen */}
        <Box 
        

          sx={{
            backgroundColor: ColorTarjeta,
            borderRadius: 4,
            color: 'white',
            px: 2,
            pt: 0,
            pb: 3,
            mt: -6,
            mx: 1,
            boxShadow: 4,
            position: 'relative',
            zIndex: 1,


            // NUEVOS:
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start', // Para distribuir contenido
            height: Height, // Asegura altura completa si padre lo permite
            minHeight: '300px', // Puedes ajustar este valor según lo que desees
          }}
        className='Etiqueta'
        >
          <Typography mt='58px' variant="h3"  sx={{ color: TituloColor, fontSize:TituloSize, fontWeight:TituloWeight}} >
            {TituloContenido}
          </Typography>

          <Typography  sx={{ margin:ParrafoMargin , ineHeight:'100%', fontSize:ParrafoSize}}>
            {ParrafoContenido}
          </Typography>
 
          <List sx={{fontSize:ParrafoSize}} dense  >
            Que incluye:
            {ListaContenido.map((text, index) => (
              <ListItem key={index} disableGutters sx={{margin:'10px 0px 0px 0px', padding:'0px'}}>
                <ListItemIcon sx={{ minWidth: 24 }}>
                  <FiberManualRecordIcon sx={{ fontSize:'18px', color: 'yellow' }} />
                </ListItemIcon>
                <Typography 
                sx={{margin:'0px 0px 0px 7px', lineHeight:'100%', fontSize:ParrafoSize}}>{text}</Typography>
              </ListItem>
            ))}
          </List>
          <Box
            sx={{
              position: 'absolute',
              top: '-40px', // ajusta según el diseño
              right: 20,
              width: 67,
              height: 67,
              bgcolor: 'yellow',
              borderRadius: 3, // menos redondeado que un círculo
              border: '4px solid yellow',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2,
            }}
          >
            {Icono}
          </Box>
        </Box>

        {/* Ícono que flota sobre todo */}

      </Card>

      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }} >
        <Button onClick={onClick}
          sx={{
            mt:{xs:'30px',sm:'20px'} ,
            width: '60%',
            padding:'10px 8px !important',
            backgroundColor: '#d14081',
            color: 'white',
            borderRadius: '6px',
            fontSize:{xs:'18px',sm:'18px'},
            textTransform: 'none',
            '&:hover': {
              color:'#d14081',
              backgroundColor: 'white',
              boxShadow: '0 0 0 1px rgb(255 39 136)'
            },
          }}
        >
          Contrata ahora
        </Button>
      </Box>


    </Box>

  );
};

export default VelacionEnCasaCard;


VelacionEnCasaCard.defaultProps = {
  Imagen: VelacionCasa,
  ParrafoMargin:'8px 0px',
  ColorTarjeta: 'rgba(233, 30, 99, 0.88)',
  Icono: <HomeIcon sx={{ color: 'black' }} />,
  TituloContenido: 'Velación en casa',
  TituloSize: '28px',
  TituloColor: 'yellow',
  TituloWeight: '',
  TituloAlign: 'left',
  ParrafoContenido: 'Brinda un servicio funerario a tu ser querido en la comodidad, calidez e intimidad de tu hogar con amigos y familiares.',
  ParrafoSize: '18px',
  ParrafoColor: 'white',
  ParrafoWeight: '400 !important',
  ParrafoAlign: 'left',
  ListaContenido: [
    'Traslados',
    'Equipo de velación y mobiliario',
    'Preservación',
    'Conmemoración',
    'Y más…',
    'Desde $14,500.00'
  ],
  ListaSize: '16px !important',
  ListaColor: 'yellow',
  ListaWeight: '400 !important',
  ListaAlign: 'left',
  Height:'430px',
  Margin:'12px 0px 0px 0px'
};